export default {
    react: (data) => $nuxt.$axios.post($nuxt.$api.host + '/reaction', data),
    remove: (data) => $nuxt.$axios.delete($nuxt.$api.host + '/reaction/' + data)
}
